/**
 * @file Component to assemble other components to construct a view.
 * The view is about plannings data.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { DataViewBase } from '../../base/data-view/data-view.base';
import { Router, ActivatedRoute } from '@angular/router';
import { DomainService } from '../../domain.service';
import { DialogService } from '../../core/dialog.service';
import { AlertsService } from '../../core/alerts.service';
import { TranslateService } from '@ngx-translate/core';
/**
 * Component to assemble other components to construct a view.
 * The view is about plannings data.
 * @export
 * @class DataViewComponent
 * @extends {DataViewBase}
 */
var DataViewComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DataViewComponent, _super);
    /**
     * Creates an instance of DataViewComponent.
     * @param {Router} router The router
     * @param {ActivatedRoute} route The active route.
     * @param {DomainService} domainService Service to get the data displayed.
     * @param {DialogService} dialogService Service to create informative user dialogs.
     * @param {AlertsService} alertsService Service to inform the user of system events.
     * @param {TranslateService} translateService Service to make the application multilanguage.
     * @memberOf DataViewComponent
     */
    function DataViewComponent(router, route, domainService, dialogService, alertsService, translateService) {
        return _super.call(this, router, route, domainService, dialogService, alertsService, translateService) || this;
    }
    /**
     * Checks whether the given route is the detail route for the given item.
     * @param detailRoute The route to check.
     * @param item Checks the route for this item.
     * @returns True when detailRoute matches with the given entity otherwise false.
     */
    DataViewComponent.prototype.isDetailRouteForItem = function (detailRoute, item) {
        // Override and use the item parameter in derived classes.
        if (!_super.prototype.isDetailRouteForItem.call(this, detailRoute, item)) {
            return false;
        }
        if (item.entityType.shortName === 'SpendTime') {
            var classNameSpendTime = (item['AccountClass'] + '').toLowerCase();
            return detailRoute.path.toLowerCase().indexOf(classNameSpendTime) !== -1;
        }
        if (item.entityType.shortName === 'Assignment') {
            var classNameAssignment = (item['Appointment']) ? 'appointment' : 'assignment';
            return detailRoute.path.toLowerCase().indexOf(classNameAssignment) !== -1;
        }
        return true;
    };
    return DataViewComponent;
}(DataViewBase));
export { DataViewComponent };
